import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

export default ()=>{
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const state = useSelector((state) => state)

    return {dispatch, navigate, location, state}
}